import axios from "./axiosinstance";

const ProposalApi = {
  add: (payload) => axios.post("proposals/add", payload),

  getByLead: (leadId) =>
    axios.get(`proposals/by-lead/${leadId}`),

  download: (id) =>
    axios.get(`proposals/download/${id}`, {
      responseType: "blob",
    }),
};

export default ProposalApi;